import React from 'react'
import { createRoot } from 'react-dom/client'

import 'url-search-params-polyfill'

import { updateSubscriptionData } from '../Landing/Helper/helper.js'
import { isLoggedIntoSubscriptionCenter } from '../../../global/authentication/authentication-manager.js'
import {
  getSubscriptionsByName,
  getSubscriptionsForUser,
} from '../Data/SubscriptionCenterDataSource.js'
import CategorySubscriptionButton from './CategorySubscriptionButton.jsx'

class CategorySubscriptionButtonElement extends HTMLElement {
  async connectedCallback() {
    let subscriptionProfile

    let subscriptions = []
    const categoryName = this.dataset.category
    const buttonNotClickedText = this.dataset.buttonNotClickedText
    const buttonClickedText = this.dataset.buttonClickedText
    const productSubscribe = this.dataset.productSubscribe
    if (categoryName) {
      const categorySubscription = await getSubscriptionsByName(categoryName)

      if (isLoggedIntoSubscriptionCenter()) {
        if (categorySubscription.length > 0) {
          subscriptionProfile = await getSubscriptionsForUser()
          subscriptions = updateSubscriptionData(subscriptionProfile.value, {
            subscriptions: categorySubscription,
          })
        }
      } else {
        subscriptions = categorySubscription
      }
    }

    const reactContainerId =
      'email-subscription-center-modal-react-app' + Math.random()
    const reactContainer = document.createElement('span')
    reactContainer.setAttribute('id', reactContainerId)
    this.appendChild(reactContainer)

    const container = document.getElementById(reactContainerId)
    const root = createRoot(container)

    root.render(
      <CategorySubscriptionButton
        subscriptionProfile={subscriptionProfile}
        categorySubscription={subscriptions[0]}
        buttonNotClickedText={buttonNotClickedText}
        buttonClickedText={buttonClickedText}
        productSubscribe={productSubscribe}
      />
    )
  }
}
if (!customElements.get('category-subscription-button')) {
  customElements.define(
    'category-subscription-button',
    CategorySubscriptionButtonElement
  )
}
